import React, { useEffect, useState, useCallback, useContext } from "react";
import {
	Container,
	Image,
	Row,
	Col,
	Card,
	Button,
	Form,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { AppContext } from "../../context/appContext";

const QUOTE_REQUEST_LIST_URL =
	"https://i4ljrfxm3i.execute-api.us-east-1.amazonaws.com/v1/quoteRequestForBaker";
const CONVERSATION_API_URL =
	"https://be08zhezjc.execute-api.us-east-1.amazonaws.com/v1/cakeryAppMessaging1745038939";

const tierServings = {
  14: 78,
  12: 56,
  10: 38,
  8: 24,
  6: 12,
  4: 8,
};

const tierConfigs = {
  6: [14, 12, 10, 8, 6, 4],
  5: [14, 12, 10, 8, 6],
  4: [12, 10, 8, 6],
  3: [10, 8, 6],
  2: [8, 6],
  1: [8],
};

const BakerQuoteRequestDetail = () => {
  const { id, bakeryName } = useParams();
  const { setGlobalLoading, userSub } = useContext(AppContext);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [guestEmail, setGuestEmail] = useState("");
  const [numTiers, setNumTiers] = useState(1);
  const [tierShape, setTierShape] = useState("round");
  const [cakeFlavors, setCakeFlavors] = useState({});
  const [icingFlavors, setIcingFlavors] = useState({});
  const [fillingFlavors, setFillingFlavors] = useState({});
  const [selectedDietaryRestrictions, setSelectedDietaryRestrictions] = useState(
    [],
  );
  const [decorations, setDecorations] = useState([]);
  const [designNotes, setDesignNotes] = useState("");
  const [bakerPrice, setBakerPrice] = useState(null);
	const [refCode, setRefcode] = useState("");
	const [tranDate, setTranDate] = useState("");
	const [chatMessage, setChatMessage] = useState("");
	const [conversation, setConversation] = useState([
		// {
		// 	userType: "Customer",
		// 	message: "Can you add a bow?",
		// 	createdAt: "2025-04-17 15:49:03",
		// },
	]);

  const [samplePhoto1Url, setSamplePhoto1Url] = useState(null);
  const [samplePhoto2Url, setSamplePhoto2Url] = useState(null);
  const [samplePhoto3Url, setSamplePhoto3Url] = useState(null);
  const [samplePhoto4Url, setSamplePhoto4Url] = useState(null);
  const [samplePhoto5Url, setSamplePhoto5Url] = useState(null);
  const [samplePhoto6Url, setSamplePhoto6Url] = useState(null);
  const [samplePhoto7Url, setSamplePhoto7Url] = useState(null);

	const fetchConversation = useCallback(async () => {
		try {
			setGlobalLoading(true);

			let url = `${CONVERSATION_API_URL}?bakery=${bakeryName}&quoteRequestId=${id}&type=qr`;
			if (userSub) {
				url = `${CONVERSATION_API_URL}?userSub=${userSub}&bakery=${bakeryName}&quoteRequestId=${id}&type=qr`;
			}
			const response = await axios.get(url);

			if (
				response.data?.data &&
				Array.isArray(response.data?.data) &&
				response.data?.data?.length > 0
			) {
				setConversation(response.data?.data);

				const conversationSection = document.getElementById("conversation-section");
				conversationSection.lastElementChild.scrollIntoView({ behavior: "smooth" });
			}
		} catch (error) {
			console.error("❌ Error fetching conversation:", error);
		}
	}, [bakeryName, id, setGlobalLoading, userSub]);

	useEffect(() => {
		fetchConversation();
	}, [fetchConversation]);

  const fetchQuoteRequestDetail = useCallback(async () => {
    if (!userSub) {
      return;
    }
    try {
      setGlobalLoading(true);

      const url = `${QUOTE_REQUEST_LIST_URL}?userSub=${userSub}&id=${id}`;
      const response = await axios.get(url);

      if (
        response.data?.data &&
        Array.isArray(response.data?.data) &&
        response.data?.data?.length > 0
      ) {
        setGuestEmail(response.data?.data[0]?.guestEmail);
        setNumTiers(response.data?.data[0]?.numTiers);
        setTierShape(response.data?.data[0]?.tierShape);
        setCakeFlavors(response.data?.data[0]?.cakeFlavors || {});
        setIcingFlavors(response.data?.data[0]?.icingFlavors || {});
        setFillingFlavors(response.data?.data[0]?.fillingFlavors || {});
        setSelectedDietaryRestrictions(response.data?.data[0]?.selectedDietaryRestrictions || []);
        setDecorations(response.data?.data[0]?.decorations || []);
        setDesignNotes(response.data?.data[0]?.designNotes);
        setBakerPrice(response.data?.data[0]?.bakerPrice);
        setRefcode(response.data?.data[0]?.refCode);
        setTranDate(response.data?.data[0]?.createdAt);
        setSamplePhoto1Url(response.data?.data[0]?.samplePhoto1Url);
        setSamplePhoto2Url(response.data?.data[0]?.samplePhoto2Url);
        setSamplePhoto3Url(response.data?.data[0]?.samplePhoto3Url);
        setSamplePhoto4Url(response.data?.data[0]?.samplePhoto4Url);
        setSamplePhoto5Url(response.data?.data[0]?.samplePhoto5Url);
        setSamplePhoto6Url(response.data?.data[0]?.samplePhoto6Url);
        setSamplePhoto7Url(response.data?.data[0]?.samplePhoto7Url);
        setGlobalLoading(false);
      }
      setGlobalLoading(false);
    } catch (error) {
      console.error("❌ Error fetching bakeries:", error);
    }
  }, [id, setGlobalLoading, userSub]);

  useEffect(() => {
    fetchQuoteRequestDetail();
  }, [fetchQuoteRequestDetail]);

  const handleUpdateQuote = async (params) => {
    try {
      setGlobalLoading(true);
      setIsSubmitting(true);

      const payload = {
        id,
        ...(userSub && { userSub }),
        bakerPrice
      };

      const response = await axios.patch(QUOTE_REQUEST_LIST_URL, payload, {
        headers: { "Content-Type": "application/json" },
      });

      alert(response?.data?.message);
      setGlobalLoading(false);
      setIsSubmitting(false);
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("There was an error submitting your inquiry.");
      setGlobalLoading(false);
      setIsSubmitting(false);
    }
  };

  const getTotalServings = () => {
    const config = tierConfigs[parseInt(numTiers)];
    if (!config) return 0;
    return config.reduce((total, size) => total + (tierServings[size] || 0), 0);
  };

  const getPriceEstimate = () => getTotalServings() * 5;

	const handleClickSend = async () => {
		const tempMessage = chatMessage;
		setConversation((prev) => [
			...prev,
			{
				userType: "Baker",
				createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
				message: tempMessage,
			},
		]);
		setChatMessage("");

		setTimeout(() => {
			const conversationSection = document.getElementById("conversation-section");
			conversationSection.lastElementChild.scrollIntoView({ behavior: "smooth" });
		}, 100);

		try {
			const payload = {
				type: "qr",
				quoteRequestId: id,
				userSub,
				userType: "Baker",
				bakery: bakeryName,
				message: tempMessage,
			};

			await axios.post(CONVERSATION_API_URL, payload, {
				headers: { "Content-Type": "application/json" },
			});
		} catch (error) {
			console.log(error);
		}
	};

  return (
			<Container className="py-5">
				<div className="text-center mb-3">
					<h4>Ref Code : {refCode || "-"}</h4>
					<h4>
						Date : {tranDate ? `${moment(tranDate).format("YYYY/MM/DD")}` : "-"}
					</h4>
					<h4>{guestEmail}</h4>
				</div>

				<Card className="shadow-sm" style={{ borderRadius: "15px" }}>
					<Card.Body style={{ padding: "30px" }}>
						<Row>
							{/* LEFT SIDE - FORM */}
							<Col md={6}>
								<h5>Quote Request Detail</h5>

								<Col className="mt-3">
									<Row>
										<Col md={4}>Tier Preferences</Col>
										<Col>: {numTiers || "-"}</Col>
									</Row>
									<Row>
										<Col md={4}>Tier Shape</Col>
										<Col>: {tierShape || "-"}</Col>
									</Row>
								</Col>

								<Col className="mt-3">
									{Array.from({ length: numTiers }, (_, i) => (
										<div key={i} className="mb-3 p-3 border rounded">
											<h5 className="fw-bold">Tier {i + 1}</h5>
											<Row>
												<Col md={4}>Cake Flavor</Col>
												<Col>: {cakeFlavors[i + 1] || "-"}</Col>
											</Row>
											<Row>
												<Col md={4}>Filling Flavor (Optional)</Col>
												<Col>: {fillingFlavors[i + 1] || "-"}</Col>
											</Row>
											<Row>
												<Col md={4}>Icing Flavor</Col>
												<Col>: {icingFlavors[i + 1] || "-"}</Col>
											</Row>
										</div>
									))}
								</Col>

								<Col className="mt-3">
									<Row>
										<Col md={4}>Dietary Restrictions</Col>
										<Col>: {selectedDietaryRestrictions || "-"}</Col>
									</Row>
									<Row>
										<Col md={4}>Decorations</Col>
										<Col>: {decorations || "-"}</Col>
									</Row>
									<Row>
										<Col md={4}>Design Notes / Additional Requests</Col>
										<Col>: {designNotes || "-"}</Col>
									</Row>
								</Col>

								<Col className="mt-3">
									<p>Sample Photo(s)</p>
									<Row style={{ marginBottom: "10px" }}>
										<Col style={{ position: "relative" }}>
											{samplePhoto1Url && (
												<Image
													src={samplePhoto1Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
										<Col style={{ position: "relative" }}>
											{samplePhoto2Url && (
												<Image
													src={samplePhoto2Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
									</Row>
									<Row style={{ marginBottom: "10px" }}>
										<Col style={{ position: "relative" }}>
											{samplePhoto3Url && (
												<Image
													src={samplePhoto3Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
										<Col style={{ position: "relative" }}>
											{samplePhoto4Url && (
												<Image
													src={samplePhoto4Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
									</Row>
									<Row style={{ marginBottom: "10px" }}>
										<Col style={{ position: "relative" }}>
											{samplePhoto6Url && (
												<Image
													src={samplePhoto6Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
										<Col style={{ position: "relative" }}>
											{samplePhoto7Url && (
												<Image
													src={samplePhoto7Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
									</Row>
									<Row style={{ marginBottom: "10px" }}>
										<Col style={{ position: "relative" }}>
											{samplePhoto5Url && (
												<Image
													src={samplePhoto5Url}
													rounded
													style={{ width: "200px", height: "200px" }}
												/>
											)}
										</Col>
									</Row>
								</Col>

								<Form.Group className="mt-3 mb-3">
									<Form.Label>Price</Form.Label>
									<Row>
										<Col xl={4}>
											<Form.Control
												autoFocus
												type="number"
												placeholder="Enter bakery price"
												value={bakerPrice}
												onChange={(e) => setBakerPrice(e.target.value)}
												style={{
													maxWidth: "200px",
												}}
											/>
										</Col>
										<Col>
											<Button
												onClick={handleUpdateQuote}
												disabled={isSubmitting || !bakerPrice}
												style={{
													// height: "40px",
													backgroundColor: "#FEA2C2",
													border: "none",
													color: "white",
													fontWeight: "bold",
													padding: "8px 24px",
													fontSize: "1.1rem",
													borderRadius: "8px",
													boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
													transition: "all 0.3s ease-in-out",
													opacity: isSubmitting ? 0.6 : 1,
													cursor: isSubmitting ? "not-allowed" : "pointer",
												}}>
												{isSubmitting ? "Submitting..." : "🎂 Submit Price"}
											</Button>
										</Col>
									</Row>
								</Form.Group>

								<Form.Group className="mt-3">
									<Col
										style={{
											padding: "16px",
											border: "1px solid gray",
											borderRadius: "8px",
										}}>
										<Form.Label>
											<h5>Discussion:</h5>
										</Form.Label>
										<Col
											id="conversation-section"
											className="mb-3"
											style={{
												maxHeight: "100px",
												overflow: "scroll",
											}}>
											{conversation?.map((c, i) => {
												return (
													<div
														key={i.toString()}
														style={{
															display: "flex",
															flexDirection: "row",
															alignItems: "flex-start",
															justifyContent: "flex-start",
														}}>
														<span>{c.userType}</span>
														<span style={{ marginRight: "5px", marginLeft: "5px" }}>
															{moment(c.createdAt).format("M/DD")}
														</span>
														<span>: {c.message}</span>
													</div>
												);
											})}
										</Col>
										<Row>
											<Col xl={10}>
												<Form.Control
													as="textarea"
													placeholder="type your message here"
													rows={1}
													value={chatMessage}
													onChange={(e) => setChatMessage(e.target.value)}
													on
												/>
											</Col>
											<Col xl={2}>
												<Button
													disabled={!chatMessage}
													style={{
														backgroundColor: "#FEA2C2",
														border: "none",
														color: "white",
														fontWeight: "bold",
													}}
													onClick={handleClickSend}>
													Send
												</Button>
											</Col>
										</Row>
									</Col>
								</Form.Group>
							</Col>

							{/* RIGHT SIDE - CAKE IMAGE & SUMMARY */}
							<Col
								md={6}
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "space-between",
								}}>
								<Col className="text-center">
									<img
										src={`/${numTiers}tier_${tierShape.toLowerCase()}.png`}
										alt={`${numTiers} Tier Cake`}
										style={{
											width: "220px", // 👈 shrink this if needed
											height: "auto",
											marginBottom: "16px",
											borderRadius: "10px",
											display: "block",
											marginLeft: "auto",
											marginRight: "auto",
										}}
									/>

									<h4>Estimate Price ${getPriceEstimate()}</h4>
									<h5>{getTotalServings()} Servings</h5>
									{/* Cake & Icing Breakdown */}
									{numTiers > 1 && (
										<div className="mt-4 text-start">
											<h5 className="fw-bold">Cake & Icing Breakdown:</h5>
											<ul className="list-unstyled">
												{Array.from({ length: numTiers }, (_, i) => (
													<li key={i} className="mb-2">
														<strong>Tier {i + 1}:</strong>
														<span className="text-muted">
															{" "}
															{cakeFlavors[i + 1] || "Not selected"} cake
														</span>
														,
														<span className="text-muted">
															{" "}
															{icingFlavors[i + 1] || "Not selected"} icing
														</span>
														,
														<span className="text-muted">
															{" "}
															{fillingFlavors[i + 1] || "Not selected"} filling
														</span>
													</li>
												))}
											</ul>
										</div>
									)}

									{/* Dietary Restrictions */}
									{selectedDietaryRestrictions.length > 0 && (
										<div className="mt-3 text-start">
											<h5 className="fw-bold">Dietary Restrictions:</h5>
											<p className="text-muted">
												{selectedDietaryRestrictions?.map((d) => d.label).join(", ")}
											</p>
										</div>
									)}

									{/* Decorations */}
									{decorations.length > 0 && (
										<div className="mt-3 text-start">
											<h5 className="fw-bold">Extras:</h5>
											<p className="text-muted">
												{decorations?.map((d) => d.label).join(", ")}
											</p>
										</div>
									)}

									{/* Design Notes */}
									{designNotes && (
										<div className="mt-3 text-start">
											<h5 className="fw-bold">Additional Design Notes:</h5>
											<p className="text-muted">{designNotes}</p>
										</div>
									)}
								</Col>
								<Row>
									<Col xl={6}></Col>
									<Col xl={6} style={{ textAlign: "right" }}>
										<Button
											onClick={() => {}}
											disabled={isSubmitting}
											style={{
												width: "200px",
												height: "80px",
												backgroundColor: "#FEA2C2",
												border: "none",
												color: "white",
												fontWeight: "bold",
												padding: "12px 24px",
												fontSize: "1.1rem",
												borderRadius: "8px",
												boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
												transition: "all 0.3s ease-in-out",
												opacity: isSubmitting ? 0.6 : 1,
												cursor: isSubmitting ? "not-allowed" : "pointer",
											}}>
											{isSubmitting ? "Submitting..." : "Approve Quote"}
										</Button>
									</Col>
								</Row>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Container>
		);
};

export default BakerQuoteRequestDetail;